import * as React from 'react';
import Icon from 'src/components/icon';
import { WhiteOutlineButton } from 'src/components/button';

import MediaUploader from 'src/components/mediaUploader';

import {
  StyledLabel,
  StyledPrefixLabel,
  StyledInput,
  StyledTextArea,
  StyledUnderlineInput,
  StyledHiddenInput,
  StyledCheckboxWrapper,
  StyledError,
  StyledSuccess,
  PhotoInputLabel,
  CoverInputLabel,
  InputOverlay,
  CoverImage,
  PhotoInputImage,
  StyledTextAreaWrapper,
  StyledAction,
} from './style';
import styled from 'styled-components';

export const Input = props => {
  return (
    <StyledLabel {...props}>
      {props.children}
      <StyledInput
        data-testid={props.testId}
        id={props.id}
        type={props.inputType}
        defaultValue={props.defaultValue}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.onChange}
        autoFocus={props.autoFocus}
        disabled={props.disabled}
        data-cy={props.dataCy}
      />
    </StyledLabel>
  );
};

const PhotoInputBg = styled.div`
  width: 34px;
  height: 34px;
  background: #464ac9;
  position: relative;
  border-radius: 8px;
  > img {
    border-radius: 8px;
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
export const PhotoInput = props => {
  const { size = 30, type, defaultValue, onChange, testId } = props;
  let imageSize = 22;
  let visible,
    src = defaultValue;
  if (!src || src.length === 0) {
    visible = true;
    src =
      type === 'user' ? '/img/default_avatar.svg' : '/img/add-to-photos.svg';
  } else {
    imageSize = 34;
  }

  return (
    <PhotoInputLabel type={type} size={size}>
      {/* <InputOverlay type={type} size={size} visible={visible}>
        <Icon glyph="photo" />
      </InputOverlay> */}
      <PhotoInputBg>
        <PhotoInputImage
          type={type}
          alt={'Profile photo'}
          src={src}
          size={imageSize}
        />
      </PhotoInputBg>

      <StyledHiddenInput
        type="file"
        id="file"
        name="file"
        accept={'.png, .jpg, .jpeg'}
        multiple={false}
        onChange={onChange}
        data-testid={testId}
      />
    </PhotoInputLabel>
  );
};

export const CustomizedPhotoInput = props => {
  const { size = 30, type, defaultValue, onChange, dataCy } = props;

  let visible,
    src = defaultValue;
  if (!src || src.length === 0) {
    visible = true;
    src =
      type === 'user'
        ? '/img/default_avatar.svg'
        : '/img/default_community.svg';
  }

  return (
    <PhotoInputLabel type={type} size={size}>
      <InputOverlay type={type} size={size} visible={visible}>
        <Icon glyph="photo" />
      </InputOverlay>

      <PhotoInputImage
        type={type}
        alt={'Profile photo'}
        src={src}
        size={size}
      />

      <StyledHiddenInput
        type="file"
        id="file"
        name="file"
        accept={'.png, .jpg, .jpeg'}
        multiple={false}
        onChange={onChange}
        data-testid={props.testId}
      />
    </PhotoInputLabel>
  );
};

export const CoverInput = props => {
  return (
    <CoverInputLabel>
      <InputOverlay
        visible={!props.defaultValue || props.defaultValue.length === 1}
      >
        <WhiteOutlineButton as={'div'}>Add Cover Photo</WhiteOutlineButton>
      </InputOverlay>
      <CoverImage
        src={props.defaultValue ? `${props.defaultValue}` : ''}
        role="presentation"
      />
      <StyledHiddenInput
        type="file"
        id="file"
        name="file"
        accept={
          props.allowGif ? '.png, .jpg, .jpeg, .gif, .mp4' : '.png, .jpg, .jpeg'
        }
        multiple={false}
        onChange={props.onChange}
        data-cy={props.dataCy}
      />
    </CoverInputLabel>
  );
};

export const Checkbox = props => {
  return (
    <StyledLabel>
      <StyledCheckboxWrapper
        disabled={props.disabled || false}
        align={props.align || 'center'}
        data-testId={
          props.testId
            ? `${props.testId}-${props.checked ? 'checked' : 'unchecked'}`
            : null
        }
      >
        {props.checked ? <Icon glyph="check" /> : <Icon glyph="uncheck" />}
        <StyledHiddenInput
          type="checkbox"
          id={props.id}
          checked={props.checked}
          disabled={props.disabled || false}
          onChange={props.onChange}
          data-testId={props.testId}
        />
        {props.children}
      </StyledCheckboxWrapper>
    </StyledLabel>
  );
};

export const TextArea = props => {
  return (
    <StyledLabel>
      {props.children}
      <StyledTextAreaWrapper>
        <StyledTextArea
          data-testid={props.testId}
          value={props.value}
          id={props.id}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          autoFocus={props.autoFocus}
          data-cy={props.dataCy}
          rows="3"
        />
        {props.showAction ? (
          <StyledAction>
            {/* <Icon glyph="insert-emotion" onClick={props.showEmojiPicker} /> */}
            {props.previewMedia ? (
              <MediaUploader
                isSendingMediaMessage={false}
                currentUser={props.currentUser}
                onValidated={props.previewMedia}
                onError={props.mediaError}
                data-testid="upload-media"
              />
            ) : null}
          </StyledAction>
        ) : null}
      </StyledTextAreaWrapper>
    </StyledLabel>
  );
};

export class UnderlineInput extends React.Component {
  render() {
    return (
      <StyledPrefixLabel disabled={this.props.disabled}>
        {this.props.children}
        <StyledUnderlineInput
          type="text"
          id={this.props.id}
          placeholder={this.props.placeholder}
          value={this.props.value || this.props.defaultValue}
          onChange={this.props.onChange}
          autoFocus={this.props.autoFocus}
          disabled={this.props.disabled}
          data-cy={this.props.dataCy}
        />
      </StyledPrefixLabel>
    );
  }
}

export const Error = props => {
  const { children, ...rest } = props;
  return <StyledError {...rest}>{children}</StyledError>;
};

export const Success = props => {
  const { children, ...rest } = props;
  return <StyledSuccess {...rest}>{children}</StyledSuccess>;
};
